import {getMediaAssetProps} from '~/cms/helpers/getMediaAssetProps'
import {
  type HgArticleWYSIWYGMediaAssetProps,
  HgArticleWYSIWYGMediaAsset,
} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'
import {wysiwygComponentVariants} from '../../_utils/variants'
import {type WysiwygMediaAssetFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGMediaAssetProps = WysiwygMediaAssetFragment & {
  openLightbox: NonNullable<HgArticleWYSIWYGMediaAssetProps['openLightbox']>
}

export const DatoWYSIWYGMediaAsset = ({
  openLightbox,
  layoutSize,
  assetComponent,
}: DatoWYSIWYGMediaAssetProps) => {
  const size = layoutSize as HgArticleWYSIWYGMediaAssetProps['size']
  const {mediaAsset} = wysiwygComponentVariants({mediaAssetSize: size})

  return (
    <HgArticleWYSIWYGMediaAsset
      {...getMediaAssetProps(assetComponent)}
      openLightbox={openLightbox}
      size={layoutSize as HgArticleWYSIWYGMediaAssetProps['size']}
      classNames={{wrapper: mediaAsset()}}
    />
  )
}
